interface PaginationProps {
  current: number;
  total: number;
  onChange: (page: number) => void;
}

export default function Pagination({ current, total, onChange }: PaginationProps) {
  if (total <= 1) return null;

  const pages: (number | string)[] = [];
  for (let i = 1; i <= total; i++) {
    if (i === 1 || i === total || Math.abs(i - current) <= 1) {
      pages.push(i);
    } else if (pages[pages.length - 1] !== '...') {
      pages.push('...');
    }
  }

  const btnBase =
    'min-w-9 h-9 px-3 rounded-md text-sm font-medium flex items-center justify-center transition-colors whitespace-nowrap cursor-pointer';

  return (
    <div className="flex items-center justify-center flex-wrap gap-2 mt-10">
      <button
        onClick={() => onChange(Math.max(1, current - 1))}
        disabled={current === 1}
        className={`${btnBase} border border-background-300 text-foreground-700 hover:bg-background-100 disabled:opacity-40 disabled:cursor-not-allowed`}
        aria-label="上一页"
      >
        <i className="ri-arrow-left-s-line"></i> 上一页
      </button>

      {pages.map((p, i) =>
        typeof p === 'number' ? (
          <button
            key={i}
            onClick={() => onChange(p)}
            className={`${btnBase} ${
              p === current
                ? 'bg-primary-500 text-white'
                : 'border border-background-300 text-foreground-700 hover:bg-background-100'
            }`}
          >
            {p}
          </button>
        ) : (
          <span key={i} className="px-1 text-foreground-400">
            {p}
          </span>
        )
      )}

      <button
        onClick={() => onChange(Math.min(total, current + 1))}
        disabled={current === total}
        className={`${btnBase} border border-background-300 text-foreground-700 hover:bg-background-100 disabled:opacity-40 disabled:cursor-not-allowed`}
        aria-label="下一页"
      >
        下一页 <i className="ri-arrow-right-s-line"></i>
      </button>
    </div>
  );
}